export const apiRoutes = {
  allPeople: () => "/people",
  peopleById: (id: string | number) => `/people/${id}`,
  searchUserByName: (name: string) => `/people/?search=${name}`,
  peoplesByPage: (pageId: number | string) => `people/?page=${pageId}`,
};
